import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

import { DigitalOrderSheet } from "@app/data/digital-order-sheet";

@Injectable()
export class DigitalOrderSheetService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  digitalOrderSheetsUrl = "api/v2/digital-order-sheets";

  constructor(private httpClient: HttpClient) {}

  query(page: number): Promise<DigitalOrderSheet[]> {
    let url = `${this.digitalOrderSheetsUrl}?page=${page}&limit=25`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as DigitalOrderSheet[])
      .catch(this.handleError);
  }

  get(id: string): Promise<DigitalOrderSheet> {
    const url = `${this.digitalOrderSheetsUrl}/${id}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((response) => response as DigitalOrderSheet)
      .catch(this.handleError);
  }

  delete(id: string): Promise<void> {
    const url = `${this.digitalOrderSheetsUrl}/${id}`;
    return this.httpClient
      .delete(url, { headers: this.httpHeaders })
      .toPromise()
      .then(() => null)
      .catch(this.handleError);
  }

  create(digitalOrderSheet: DigitalOrderSheet): Promise<DigitalOrderSheet> {
    const url = `${this.digitalOrderSheetsUrl}`;
    return this.httpClient
      .post(url, digitalOrderSheet, { headers: this.httpHeaders })
      .toPromise()
      .then((res) => res as DigitalOrderSheet)
      .catch(this.handleError);
  }

  update(digitalOrderSheet: DigitalOrderSheet): Promise<DigitalOrderSheet> {
    const url = `${this.digitalOrderSheetsUrl}/${digitalOrderSheet._id}`;
    return this.httpClient
      .put(url, JSON.stringify(digitalOrderSheet), {
        headers: this.httpHeaders,
      })
      .toPromise()
      .then(() => digitalOrderSheet)
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
